// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetchOrder, toggleMenu, clear, updateOrder} from '../../actions/customerView';
import CustomerOrderContainer from '../CustomerOrderContainer/CustomerOrderContainer';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import ServerError from '../../components/ServerError/ServerError';
import Navigation from '../../components/Navigation/Navigation';
import './AdminCustomerContainer.css';

export type Props = {
  orderId: string,
  apartment?: any,
  order?: any,
  project?: any,
  isFetching?: boolean,
  error?: any,
  fetchOrder: Function,
  clear: Function,
  updateOrder: Function,
};

class AdminCustomerContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    const {orderId, fetchOrder} = this.props;
    fetchOrder(orderId);
  }

  componentWillUnmount() {
    this.props.clear();
  }

  render() {
    const {
      project,
      order,
      apartment,
      isFetching,
      updateOrder,
      error,
    } = this.props;

    return (
      <div className="AdminCustomerContainer">
        {order && apartment &&
          <div>
            <div className="row align-justify align-middle content-header">
              <div className="column shrink">
                <div className="row no-row-margins align-middle">
                  <Navigation />
                  <div className="content-title">
                    Kundorder - {order.user.username}
                  </div>
                </div>
              </div>
            </div>
            <ServerError error={error} />
            <CustomerOrderContainer
              showHeader={false}
              order={order}
              project={project}
              apartment={apartment}
              updateOrder={updateOrder} />
          </div>
        }
        {isFetching &&
          <LoadingIndicator
            isLoading={true}
            isGlobal={true}/>
        }
      </div>
    );
  }
}

const mapStateToProps = ({
  customerView: {
    order: {
      order,
      project,
      apartment,
      error,
      isFetching,
    },
    showMenu,
  },
}) => ({
  order,
  project,
  apartment,
  error,
  isFetching,
  showMenu,
});

const mapDispatchToProps = dispatch => ({
  fetchOrder: id =>
    dispatch(fetchOrder(id)),
  toggleMenu: show =>
    dispatch(toggleMenu(show)),
  clear: () =>
    dispatch(clear()),
  updateOrder: (id, state) =>
    dispatch(updateOrder(id, state)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCustomerContainer);



// WEBPACK FOOTER //
// ./src/containers/AdminCustomerContainer/AdminCustomerContainer.js